<template>
	<div class="header">
		<div class="smallH">
			<div class="barprebox flexRow justBetween">
				<ul class="barpre flexRow">
					<!-- <li class="barlist activeH">
						<a href="/front/#/" class="elink">3D零件库</a>
					</li> -->
					<li class="barlist">选型&询价</li>
					<li class="barlist">周一至周日 8:30-18:00</li>
					<li class="barlist">0311-85232959</li>
				</ul>
				<div class="loginBtn" @click="handLogin('')" v-if="loginFlag==true"><span class="ahover"><i
							class="iconfont icon-dengluyonghu"></i>登录</span><span class="ml10 ahover"><i
							class="iconfont icon-yuzhuceqiye"></i>注册</span></div>
				<div class="loginBtn" v-else>
					<el-popover placement="top-start" width="100" trigger="hover">
						<span class="ml10 curhand ahover" @click="handOut()"><i
								class="iconfont icon-tuichu1"></i>退出</span>
						<a href="/people/baseinfo" class="ahover" slot="reference"><i
								class="iconfont icon-dengluyonghu"></i>{{username}}</a>
					</el-popover>
					<!-- <a href="/front/#/people/baseinfo" class="ahover"><i class="iconfont icon-dengluyonghu"></i>{{username}}</a> -->
					<!-- <span @click="Handehoutai" v-show="htFlag==true"><i class="iconfont icon-weibiaoti-1"></i>后台管理</span> -->
					<!-- <span @click="Handehoutai" ><i class="iconfont icon-weibiaoti-1"></i>后台管理</span> -->
					<!-- <span class="ml10" @click="handOut()"><i class="iconfont icon-tuichu1"></i>退出</span> -->
				</div>
			</div>
		</div>
		<div class="bgfff pad35 clearfix" v-show="message!='vipmember'&& message!='contact'&& message!='company'">
			<el-row>
				<el-col :span="24">
					<div class="w1350">
						<div class="w360">
							<!--  style="width: 360px; height: 60px;" -->
							<a href="/"><img src="../assets/partlogo.jpg" fit="scale-down" /></a>
						</div>
						<div class="w810">
							<div style="margin: 0 auto; max-width: 100%;margin-left: 40px;">
								<el-cascader v-model="casmodel" :placeholder="valueCate!=''?valueCate:'目录分类'"
									v-show="cateshow==true" :options="options" ref="refHandle" :props="optionProps"
									@change="handleChange" clearable class="caseDiv">
									<template slot-scope="{ node, data }">
										<i :class="data.id | classFilter(data.parent_id)"></i>
										<span>{{ data.title }}</span>
									</template>
								</el-cascader>
								<el-input placeholder="请输入零件分类、零件名称或相关文字" :class="[cateshow==true?'witI':'witC']"
									prefix-icon="el-icon-search" v-model="input3" class="input-with-select">
									<el-button slot="append" @click="handcateSearch()">搜索</el-button>
								</el-input>
								<!-- <div class="scate">
									<el-link :underline="false">直线轴承</el-link>
									<el-link :underline="false">弹簧</el-link>
									<el-link :underline="false">联轴器</el-link>
									<el-link :underline="false">脚轮</el-link>
									<el-link :underline="false">铰链</el-link>
									<el-link :underline="false">螺丝</el-link>
								</div> -->
							</div>
						</div>
						<div class="w200">
							<el-button type="primary" class="fbubtn" plain icon="el-icon-top" @click="Handehoutai">
								发布产品目录</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div v-show="message=='company'">
			<el-row>
				<el-col :span="24">
					<div class="w1350 bgwhite logD">
						<div class="fl mt25 ">
							<!--  style="width: 360px; height: 60px;" https://static.mfcad.com/lingbujian/win-img/partlogo1.jpg-->
							<a href="/"><img :src="cimg" fit="scale-down" class="midImg"
									style="width: 60px; height: 60px; border-radius: 50px;" v-if="cimg!=''"/></a>
							<span class="bold" v-if="company!=''">{{company}}</span>
						</div>
					</div>
				</el-col>
			</el-row>
			<div class="mendiv" style="width: 100%; background-color: #005dbe;">
				<div class="flexRow justBetween barprebox">
					<el-menu :default-active="routePath" router class="el-menu-demo" mode="horizontal"
						background-color="#005dbe" text-color="#fff" active-text-color="#ffd04b">
						<el-menu-item :index="'/company/icompany?cid='+cuserid">首页</el-menu-item>
						<el-menu-item index="/company/cgoodslist">产品</el-menu-item>
						<el-menu-item index="/company/creden">企业资质</el-menu-item>
						<el-menu-item index="/company/newslist">新闻中心</el-menu-item>
					</el-menu>
				</div>
			</div>
		</div>
		<div class="mui-mbar-tabs">
			<div class="quick_link_mian">
				<div class="quick_links_panel">
					<div id="quick_links" class="quick_links">
						<li @mousemove="handlekfMove" @mouseleave="handlekfOut">
							<a href="javascript:;" class="history_list rightA">
								<i class="iconfont icon-kefu-tianchong-copy view" v-if="show1==false"></i>
								<div class="spanpane" v-else-if="show1==true">联系客服</div>
							</a>
							<div class="mp_qrcode curhand" id="kftooltip" style="display:none;">
								<p class="curhand txl"><em class="iconfont icon-qq mr10"></em><a
										href="https://wpa.qq.com/msgrd?v=3&uin=3356096612&site=qq&menu=yes"
										target="_blank" class="hoverA txc">QQ客服</a></p>
								<p class="curhand txl mt5"><em class="iconfont icon-web__kefudianhua mr10"></em><a
										:href="'tel:18633017975'" class="hoverb">18633017975</a></p>
								<hr class="clo1">
								<img src="../assets/wx.jpg" width="148" height="148" />
								<p class="font14 mt5">添加客服微信</p>
								<i class="icon_arrow_white"></i>
							</div>
						</li>
						<hr class="linhr">
						<li @mousemove="handlewxMove" @mouseleave="handlewxOut"><a href="javascript:;"
								class="mpbtn_histroy rightA"><i class="iconfont icon-erweima zuji"
									v-if="show2==false"></i>
								<div class="spanpane" v-else-if="show2==true">公众号</div>
							</a>
							<div class="mp_qrcode curhand" id="wxqrcode" style="display:none;"><img
									src="../assets/u13.jpg" width="148" height="148" />
								<p class="font14 mt5">更多即时动态</p>
								<p class="font14 mt5">请关注公众号</p>
								<i class="icon_arrow_white"></i>
							</div>
						</li>
						<hr class="linhr">
						<li @click="handJumpC('people/collection')" @mousemove="handlecoMove('col')"
							@mouseleave="handlecoOut('col')">
							<a href="javascript:;" class="mpbtn_wdsc rightA"><i class="iconfont icon-collection-b wdsc "
									v-if="show3==false"></i>
								<div class="spanpane" v-else-if="show3==true">收藏产品</div>
								<em class="icril" v-show="colnum>0">{{colnum}}</em>
							</a>
						</li>
					</div>
					<div class="quick_toggle" @mousemove="handlecoMove('top')" @mouseleave="handlecoOut('top')">
						<li @click="returnTop"><a href="javascript:;" class="return_top rightA"><i
									class="iconfont icon-fanhuidingbu1 top" v-if="show4==false"></i>
								<div class="spanpane" v-else-if="show4==true">返回顶部</div>
							</a></li>

					</div>
				</div>

			</div>
		</div>

	</div>

</template>

<script>
	import Cookies from 'js-cookie'
	import countTo from 'vue-count-to'
	export default {
		name: "Header",
		components: {
			// sHeader,
			countTo
		},

		data() {
			return {
				// 右侧悬浮
				cirFlag: false,
				show1: false,
				show2: false,
				show3: false,
				show4: false,
				colnum: 0,
				// 结束
				options: [],
				optionProps: {
					value: 'id',
					label: 'title'
				},
				searchInput: '',
				// 需要滚动的时间
				duration: 1500,
				// 初始值
				startVal: 0,
				// 最终值
				year_search_num: 0,
				chanpinmulu: 0,
				moxingwenjian: 0,
				zhuceyonghu: 0,
				down_num: 0,
				firstID: 0,
				input3: '',
				cateshow: false,
				loginFlag: true,
				username: '',
				userImg: '',
				auth: '',
				ticket: '',
				htFlag: false,
				// 浏览器拦截问题
				HUrl: '',
				casmodel: [],
				valueCate: '',
				bindmobile: '',
				mobile: '',
				activeIndex2: '1',
				cuserid: '',
				company: '',
				cimg: '',
			};

		},
		props: ["message"],
		filters: {
			classFilter(i, pid) {
				if (i >= 37 && pid == 1) {
					return 'iconfont icon-cateiconOther';
				} else if (i > 0 && i <= 36) {
					return 'iconfont icon-cateicon' + i;
				}
			}
		},
		created() {
			this.cuserid = Cookies.get('cuserid');
			if (this.$route.path == '/company/icompany') {
				this.routePath = "/company/icompany?cid=" + this.cuserid
			} else {
				this.routePath = this.$route.path
			}
			this.handentinfo()
			var url = encodeURIComponent(window.location.href);
			// console.log(url);return false;
			if (this.getUrlKey('service_ticket') != null) {
				Cookies.set('mf_service_ticket', this.getUrlKey('service_ticket'),{expires: 14});
				var mf_service_ticket = this.getUrlKey('service_ticket');
				location.href = this.handDel('service_ticket')
			}
			if (Cookies.get('mf_service_ticket') !== undefined) {
				this.ticket = Cookies.get('mf_service_ticket').split('.');
				this.$postcn('partshome/LoadUserInformation', {}, this).then((res) => {
					this.username = res.data.username;
					this.userImg = res.data.headimg_s;
					this.auth = res.data.auth;
					this.bindmobile = res.data.bindmobile;
					this.mobile = res.data.mobile;
					this.colnum = res.data.productCollection;
					Cookies.set('userid', res.data.user_id);
					this.$postcn("user/register", {
						username: this.username,
						jurisdiction: 2,
						status: 1
					}, this).then((res) => {
						if (res.data.code == -4007) {
							this.loginFlag = true
						} else if (res.data.code = 200) {
							this.loginFlag = false;
						}
					})
				})
			}else {
				this.$postcn("user/register", {
					username: this.username,
					jurisdiction: 2,
					status: 1
				}, this).then((res) => {
					if(res.data.code==-4004){
						this.loginFlag = true
					}
					// if (res.data.code == -4007) {
					// 	this.loginFlag = true
					// } else if (res.data.code = 200) {
					// 	this.loginFlag = false;
					// }
				})
			}

			this.handPrrove();
			if (this.$route.name == 'index' || this.$route.name == 'catelist') {
				this.cateshow = false
			} else {
				this.cateshow = true
			}
			this.handtime();
			this.handCate();
			this.handleChange();
			if (this.$route.query != '') {
				this.input3 = this.$route.query.keyword;
			}
			if (this.$route.query.catname != undefined) {
				this.valueCate = this.$route.query.catname
			}
			this.casmodel = ['1', this.$route.query.cateid]
		},
		methods: {
			handentinfo() {
				this.$postcn('partshome/entinfo', {
					userid: Cookies.get('cuserid')
				}, this).then((res) => {
					if (res.data.info != null) {
						this.company = res.data.info.company
						this.cimg = res.data.info.logo[0].url
						this.$emit('func', res.data.info.banner)
					}
				})
			},
			handleSelect(key, keyPath) {
				this.activeIndex2 = key
			},
			// 右侧悬浮
			returnTop() {
				
				$("body,html").animate({
					scrollTop: 0
				}, 300);
			},
			handlekfMove() {
				$('#kftooltip').show();
				this.show1 = true;
				$('.history_list').addClass('colorhover')
			},
			handlekfOut() {
				$('#kftooltip').hide();
				this.show1 = false;
				$('.history_list').removeClass('colorhover')
			},
			handlewxMove() {
				$("#wxqrcode").show();
				this.show2 = true;
				$('.mpbtn_histroy').addClass('colorhover')
			},
			handlewxOut() {
				$("#wxqrcode").hide();
				this.show2 = false;
				$('.mpbtn_histroy').removeClass('colorhover')
			},
			handlecoMove(type) {
				if (type == 'col') {
					this.show3 = true;
				} else if (type == 'top') {
					this.show4 = true;
				}

			},
			handlecoOut(type) {
				if (type == 'col') {
					this.show3 = false;
				} else if (type == 'top') {
					this.show4 = false;
				}
			},
			handJumpC(url) {
				if (this.loginFlag == false) {
					window.open("/people/collection", '_blank');
				} else if (this.loginFlag == true) {
					this.cirFlag = false
					this.handLogin(window.location.href + url)
				}
			},
			// 结束
			// 去除登录之后跳转过来去除service_ticket
			handDel(name) {
				var loca = window.location;
				var baseUrl = loca.origin + loca.pathname + "?";
				var query = loca.search.substr(1);
				if (query.indexOf(name) > -1) {
					var obj = {}
					var arr = query.split("&");
					for (var i = 0; i < arr.length; i++) {
						arr[i] = arr[i].split("=");
						obj[arr[i][0]] = arr[i][1];
					};
					delete obj[name];
					var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g,
						"&");
					return url
				};
			},
			handPrrove() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$postcn('partshome/isauth', '', this).then((res) => {
						if (res.data.status == 1) {
							this.htFlag = true;
						} else {
							this.htFlag = false;
						}
					})
				}
			},
			// 获取地址url参数
			getUrlKey: function(name) {
				return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location
					.href) || [, ""])[
					1].replace(/\+/g, '%20')) || null
			},
			handLogin(jumpurl) {
				var url = ''
				if (jumpurl == "") {
					url = encodeURIComponent(window.location.href);
				} else {
					url = encodeURIComponent(jumpurl);
				}
				if (this.getUrlKey('service_ticket') != null) {
					Cookies.set('mf_service_ticket', this.getUrlKey('service_ticket'));
					var mf_service_ticket = this.getUrlKey('service_ticket');
					// 去除登录之后跳转过来去除service_ticket
					location.href = this.handDel('service_ticket')
				}
				if (Cookies.get('mf_service_ticket') !== undefined && this.loginFlag == false) {
					var username = Cookies.get('mf_service_ticket').split('.');
					this.$postcn('partshome/LoadUserInformation', {}, this).then((res) => {
						this.username = res.data.username;
						this.userImg = res.data.headimg_s;
						this.auth = res.data.auth;
						this.bindmobile = res.data.bindmobile;
						this.mobile = res.data.mobile;
						this.colnum = res.data.productCollection;
					})
					this.loginFlag = false;
					return this.loginFlag
				} else {
					location.href = "https://sso.mfcad.com/login/islogin?guid=3&client=pc&site=part&from_url=" + url;
				}
			},
			Handehoutai() {
				// return false;
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$postcn('partshome/isauth', '', this).then(res => {
						if (res.data.status == 1) {
							this.htFlag = true;
							window.open('https://www.mfcad.cn/houtai/renmin.html#/login')
							// this.$postcn('user/info', '', this).then(res => {
							// 	if (res) {
							// 		this.$postcn('user/permission', '', this).then((re) => {
							// 			var jsonstr = JSON.stringify(re.data);
							// 			localStorage.setItem('rolemenu', jsonstr);
							// 			// Cookies.set('userid', this.ticket[0]);
							// 			// Cookies.set('username', this.username);
							// 			if (res.roles == '超级管理员') {
							// 				Cookies.set('role', 'admin');
							// 			} else if (res.roles == '企业管理员') {
							// 				Cookies.set('role', 'enter');
							// 			}
							// 			window.open('https://www.mfcad.cn/houtai/renmin.html#/login')
							// 		})
							// 	}
							// })
						} else {
							this.$message({
								type: 'info',
								message: '您的企业认证已被驳回,请重新去认证！'
							});
							this.htFlag = false;
						}
					})
				} else {
					this.$message({
						type: 'info',
						message: '请您先进行登录！'
					});
				}
			},
			handOut() {
				// console.log(this.$router.history.current.fullPath.split('/'));return false;
				// 前端退出
				var url = window.location.href;
				// console.log(url);return false;
				Cookies.remove("mf_service_ticket");
				Cookies.remove("role");
				Cookies.remove("username");
				Cookies.remove("userid");
				Cookies.remove("tokentrn");
				console.log("url", url);
				location.href = "https://sso.mfcad.com/login/logout?from_url=" + url;
				// if (this.$router.history.current.fullPath.split('/')[1] == 'people') {
				// 	this.handLogin(window.location.href)
				// }
				// window.location.href = "/front/"
			},
			handCate() {
				this.$post('partshome/getclass', {}, this).then((res) => {
					this.options = res.data;
				})
				this.showFlag = true;
			},
			handleChange() {
				// console.log(1111)
				if (this.$refs.refHandle) {
					var children = this.$refs.refHandle.getCheckedNodes();
					this.valueCate = children[0].label;
					this.valueCateid = children[0].value;
					// console.log(this.valueCate,this.valueCateid);return false;
					// if (this.$route.path == "/list/searchlist") {
					// 	this.$parent.handcateSearch("", this.valueCateid, '', this.input3, this.valueCate);
					// } else {
					// 	let routeData = this.$router.resolve({
					// 		path: "/list/searchlist",
					// 		query: {
					// 			cateid: this.valueCateid,
					// 			keyword: this.input3,
					// 			catname: this.valueCate,
					// 		}
					// 	})
					// 	window.open(routeData.href, '_blank');
					// }
					let routeData = this.$router.resolve({
						path: "/list/catelist",
						query: {
							cateid: this.valueCateid,
						}
					})
					window.open(routeData.href, '_blank');
				}
			},
			handcateSearch(key) {
				// if (key == undefined) {
				// 	this.firstID = ''
				// } else {
				// 	this.firstID = key
				// }
				if (this.$route.name == 'catelist') {
					this.firstID = this.$route.query.cateid

				} else if (this.$route.name == 'searchlist') {
					if (this.valueCateid != undefined) {
						this.firstID = this.valueCateid
					} else {
						this.firstID = this.$route.query.cateid
					}
				} else {
					this.firstID = ''
				}
				if (this.input3 != undefined) {
					if (this.$route.path == "/list/searchlist") {
						this.$parent.handcateSearch("", this.firstID, '', this.input3, this.valueCate);
					} else {
						let routeData = this.$router.resolve({
							path: "/list/searchlist",
							query: {
								cateid: this.firstID,
								keyword: this.input3,
								catname: this.valueCate
							}
						})
						window.open(routeData.href, '_blank');
					}
				} else {
					this.$message({
						type: 'info',
						message: '请您要搜索的数据！'
					});
				}

			},
			handtime() {
				this.$postcn('partshome/tongji', {}, this).then((res) => {
					this.year_search_num = Number(res.data.year_search_num);
					this.chanpinmulu = Number(res.data.chanpinmulu);
					this.moxingwenjian = Number(res.data.moxingwenjian);
					this.zhuceyonghu = Number(res.data.zhuceyonghu);
					this.down_num = Number(res.data.down_num);

				})
			}
		}
	}
	$(window).scroll(function() {
		var scroll_len = $(window).scrollTop();
		if (scroll_len > 120) {
			$('.quick_toggle').addClass('quick_links_allow_gotop');
		} else {
			$('.quick_toggle').removeClass('quick_links_allow_gotop');
		};
	});
</script>

<style scoped="scoped">
	/* 右侧悬浮 */
	.spanpane {
		height: 100%;
		text-align: center;
		font-size: 14px;
		width: 40px;
		line-height: 20px;
		color: #ffffff;
		margin: 3px;
	}

	.icril {
		width: 15px;
		height: 15px;
		font-size: 12px;
		font-style: normal;
		right: 7px;
		top: 6px;
		position: absolute;
		background: red;
		color: #fff;
		border-radius: 15px;
		line-height: 12px;
	}

	.clo1 {
		background-color: #005dbe;
		height: 1px;
		border: none;
	}

	.hoverA {
		width: 80px;
		height: 25px;
		border: 1px solid #005dbe;
		border-radius: 5px;
		margin: 0px auto;
		line-height: 25px;
		display: inline-block;
		background: #005dbe;
		color: #FFFFFF;
		font-size: 14px;
	}


	.quick_links_wrap,
	.mui-mbar-tabs {
		height: 100%;
		/* width: 320px; */
		right: 0;
		position: fixed;
		right: 0;
		bottom: 0;
		z-index: 9;
		height: 100%;
		-webkit-transition: width linear .4s;
		-moz-transition: width linear .4s;
		-ms-transition: width linear .4s;
		transition: width linear .4s;
		_position: fixed;
		_bottom: auto;
		_top: expression(documentElement.scrollTop+documentElement.clientHeight-this.offsetHeight-10);
	}

	.quick_links_panel {
		width: 45px;
		height: auto;
		position: absolute;
		z-index: 2;
		top: 60%;
		right: 10px;
		font-family: 'microsoft yahei', arial;
	}

	.linhr {
		border: solid 1px #e6e6e6;
		margin: 0px
	}

	.quick_links_panel .rightA {
		display: block;
		width: 45px;
		line-height: 45px;
		height: 45px;
		text-decoration: none;
		color: #5a5a5a;
		font-size: 12px;
		overflow: hidden;
		position: relative;
		overflow: hidden;
		top: 0;
		left: 0px;
		*left: -15px;
		z-index: 1;
		margin: 0;
		padding: 0;
	}

	.quick_links_panel .quick_toggle {
		position: absolute;
		bottom: 0;
		left: 0;
		top: 0;
		width: 45px;
		z-index: 1;
	}

	.quick_links_panel .mp_tooltip {
		height: 38px;
		line-height: 38px;
		width: 92px;
		position: absolute;
		z-index: 2;
		left: -121px;
		top: 0;
		background: #444851;
		color: #d8d8d8;
		text-align: center;
		display: block;
		visibility: hidden;
	}

	.quick_links_panel .mp_qrcode {
		padding: 10px;
		width: 148px;
		height: auto;
		top: -157px;
		background: #fff;
		box-shadow: 0 0 5px rgba(0, 0, 0, .4);
		border-radius: 5px 0 0 5px;
		border-left: 1px solid #ccc\0;
		border-top: 1px solid #ccc\0;
		border-bottom: 1px solid #ccc\0;
		z-index: 3;
		position: absolute;
		left: -168px;
		left: -169px\0;
		display: none;
	}

	.quick_toggle .return_top {
		display: none;
	}

	.quick_links_allow_gotop .return_top {
		display: block;
		border: solid 1px #e6e6e6;
	}


	.quick_links {
		position: absolute;
		/* top: 60%; */
		left: 0;
		margin-top: -190px;
		*margin-top: -220px;
		background: rgba(255, 255, 255, 0.9);
		z-index: 2;
		width: 45px;
		border: solid 1px #e6e6e6;
	}


	.quick_links li,
	.quick_toggle li {
		background: rgba(255, 255, 255, 0.9);
		position: relative;
		display: block;
		left: 0;
		top: 0px;

	}


	.colorhover {
		background: #005dbe;
	}

	.quick_links .rightA:hover,
	.quick_links a.current,
	.quick_toggle a:hover {
		background: #005dbe;
		text-decoration: none;
	}


	/* 粘贴走 */
	.quick_links .icon-kefu-tianchong-copy,
	.icon-erweima,
	.icon-fanhuidingbu1 {
		font-size: 26px;
		vertical-align: middle;
		text-align: center;
	}

	.icon-collection-b {
		font-size: 22px;
		vertical-align: middle;
		text-align: center;
	}

	.quick_links a:hover i.view,
	.quick_links .current i.view {
		background-position: -33px -175px;
	}

	/* 粘贴走end */


	.quick_toggle .mpbtn_qrcode {
		width: 18px;
		height: 18px;
		top: 11px;
		left: 20px;
		background-position: 0 -302px;
	}

	.icon-qq,
	.icon-web__kefudianhua {
		font-size: 24px;
		vertical-align: middle;
		color: #005dbe
	}

	.hoverb {
		color: #005dbe !important;
	}

	/* 结束 */
	.ahover {
		color: #999999 !important;
	}

	.ahover:hover {
		color: #005dbe !important;
	}

	#home-section-1 {
		/* height: 430px; */
		background: #575c5c url(../assets/hbg.jpg) no-repeat center top;
		background-size: cover;
	}

	.scate {
		position: relative;
		left: -8%;
		padding-top: 8px;
	}

	.scate .el-link.el-link--default:hover {
		color: #a6a8a9;
	}

	.witI {
		width: 72%;
	}

	.witC {
		width: 90%;
	}

	.v-pan1 {
		width: 1200px;
		margin: 0px auto;
		color: #FFFFFF;
		font-weight: bold;
	}

	.h430 {
		height: 430px;
	}

	.v-pan1 .Htitle {
		font-size: 62PX;
		padding-top: 120px;
	}

	.v-pan1 .Hdesc {
		font-size: 26px;
		margin-top: 25px;
	}



	.sdiv {
		width: 600px;
		margin: 0px auto;
		margin-top: 25px;
	}

	.hidexs {
		background-color: #9a9da0;
		padding: 20px 0;
		display: none;
	}

	.itemarg {
		flex: 1;
		margin-top: -60px;
		color: #FFFFFF;
	}

	.caseDiv {
		width: 20%;
		margin-right: 15px;
	}

	/* 企业官网 */
	.logD {
		height: 110PX;
	}

	.midImg {
		vertical-align: middle;
	}

	.mendiv {
		width: 100%;
		height: 44px;
		background-color: rgb(0, 93, 190);
	}

	.mendiv .el-menu--horizontal>.el-menu-item {
		height: 44px;
		line-height: 44px;
	}
</style>

<style>
	@media screen and (-ms-high-contrast: active),
	(-ms-high-contrast: none) {

		.witI .el-input__inner {
			display: inline-block;
			height: 42px !important;
		}

		.witI .el-button {
			margin: 0px;
			display: inline-block;
		}

		.caseDiv.el-cascader .el-input__inner {
			vertical-align: middle;
		}

	}

	.el-cascader-menu__wrap {
		height: 550px !important;
	}

	.input-with-select.el-input-group--append .el-input__inner,
	.caseDiv .el-input__inner {
		border: 1px solid #005dbe;
	}

	.input-with-select .el-input--prefix .el-input__inner {
		padding-left: 30px !important;
	}

	.el-input-group__append,
	.btnNew {
		background-color: #005dbe !important;
		color: #FFFFFF !important;
		border: 1px solid #005dbe;
	}

	.el-input-group__prepend {
		border: 1px solid #005dbe;
	}

	.fbubtn.el-button--primary.is-plain:hover {
		background-color: #005dbe !important;
		color: #FFFFFF !important;
		border: 1px solid #005dbe;
	}

	.mulu .el-link.el-link--default:hover {
		color: #005dbe
	}

	.fbubtn.el-button--primary.is-plain {
		color: #005dbe;
		background: #ffffff;
		border-color: #005dbe;
	}
</style>



// WEBPACK FOOTER //
// src/components/indexheader.vue